__turbopack_context__.v({
  "badgeIcon": "styles-module__zINzcG__badgeIcon",
  "cartIcon": "styles-module__zINzcG__cartIcon",
});
